import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
    },
  });

  return position === null ? null : (
    <Marker position={position}></Marker>
  );
}

export default function MapLocationPicker({ latitude, longitude, onChange }) {
  const [position, setPosition] = useState(
    latitude && longitude ? { lat: latitude, lng: longitude } : null
  );

  const handleSetPosition = (pos) => {
    setPosition(pos);
    if (pos) {
      onChange(pos.lat, pos.lng);
    }
  };

  return (
    <div className="w-full h-64 relative rounded-lg overflow-hidden border border-gray-300">
      <MapContainer 
        center={position || [30.0444, 31.2357]} 
        zoom={position ? 13 : 5} 
        scrollWheelZoom={true} 
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
        <LocationMarker position={position} setPosition={handleSetPosition} />
      </MapContainer>
      <div className="absolute bottom-2 left-2 right-2 bg-white/90 p-2 rounded z-[1000] flex gap-2 text-sm text-black shadow">
        <input 
          type="number" 
          step="any"
          value={position ? position.lat : ''} 
          onChange={(e) => handleSetPosition({lat: parseFloat(e.target.value) || 0, lng: position?.lng || 0})}
          placeholder="Latitude" 
          className="flex-1 p-1 border border-gray-300 rounded focus:outline-none focus:border-geo-copper"
        />
        <input 
          type="number" 
          step="any"
          value={position ? position.lng : ''} 
          onChange={(e) => handleSetPosition({lat: position?.lat || 0, lng: parseFloat(e.target.value) || 0})}
          placeholder="Longitude" 
          className="flex-1 p-1 border border-gray-300 rounded focus:outline-none focus:border-geo-copper"
        />
      </div>
    </div>
  );
}
